import Api from "./Api";
import Csrf from "./Csrf";

export default {
	
	async getLock(user_id) {
		await Csrf.getCookie();
		
		return Api.get("/green-locks/"+user_id);
	},
	
	async setLock(form) {
		await Csrf.getCookie();
		
		return Api.post("/green-locks/set",form);
	},
	
	async returnLock(id) {
		await Csrf.getCookie();
		
		return Api.post("/green-locks/"+id+"/return");
	}
};